import type { FollowUpChannel, FollowUpSource } from "./db-types";
import type { FollowUpAction } from "./follow-up-calc";

export const FOLLOW_UP_CHANNEL_LABELS: Record<FollowUpChannel, string> = {
  email: "E-post",
  phone: "Telefon",
  meeting: "Møte",
  other: "Annet",
};

/** Kilden for oppfølgingen når den ikke kommer fra en regel (regler vises med ruleBadge). */
export const FOLLOW_UP_SOURCE_LABELS: Record<Exclude<FollowUpSource, "rule">, string> = {
  manual: "Manuell",
  meeting_summary: "Fra referat",
  signal: "Fra signal",
};

/** De fire utfallene på en oppfølging, med tastetall. Delt av køkortet og kundekortets «Neste steg». */
export const FOLLOW_UP_ACTIONS: ReadonlyArray<{ action: FollowUpAction; key: string; label: string }> = [
  { action: "email", key: "1", label: "E-post" },
  { action: "phone", key: "2", label: "Ring" },
  { action: "postpone", key: "3", label: "Utsett" },
  { action: "close", key: "4", label: "Avvis" },
];

/** Grunnen som lagres når en oppfølging avvises uten begrunnelse (close_follow_up krever en). */
export const FOLLOW_UP_DISMISS_NOTE = "Avvist";
